import ChallengeModePage from "./ChallengeModePage"

export default ChallengeModePage
